const en = {
  title: 'Repairs',
  subtitle: 'Repair tickets, cost estimates and inspections',
  viewList: 'List',
  viewBoard: 'Board',
  newRepairTicket: '+ New Repair Ticket',
  totalTickets: 'Total Tickets',
  allStatuses: 'All Statuses',
  allTypes: 'All Types',
  createdFrom: 'Created from',
  createdTo: 'Created to',
  priceMinPlaceholder: 'CHF min',
  priceMaxPlaceholder: 'CHF max',
  filterByCustomer: 'Filter by customer...',
  filterByDealer: 'Filter by dealer...',
  filterByDevice: 'Filter by device...',
  emptyTitle: 'No Repair Tickets Yet',
  emptyMessage: 'Create your first repair ticket to get started',
  noTicketsInColumn: 'No tickets',
  colCustomerDealer: 'Customer / Dealer',
  colDevice: 'Device',
  colCreated: 'Created',
  modalTitle: 'New Repair Ticket',
  fieldType: 'Type',
  fieldCustomer: 'Customer',
  fieldDealer: 'Dealer',
  fieldAccessories: 'Accessories',
  fieldProblemDescription: 'Problem Description',
  accessoriesPlaceholder: 'e.g., power cable, remote',
  searchOrCreateCustomer: 'Search or create customer...',
  searchOrCreateDealer: 'Search or create dealer...',
  fieldDevice: 'Device',
  searchSerialOrCreateDevice: 'Search serial number or create device...',
  attachDeviceHint:
    'Optional -- you can also attach this (or more) devices by serial number on the ticket page after creating it.',
  createTicket: 'Create Ticket',
  errorLoading: 'Error loading repair tickets: {{error}}',
  invoiceDraftedAlert:
    'ERP document drafted but left un-executed -- it still needs to be completed manually there.',
  updateStatusFailed: 'Failed to update status',
};

const de = {
  title: 'Reparaturen',
  subtitle: 'Reparaturaufträge, Kostenvoranschläge und Prüfungen',
  viewList: 'Liste',
  viewBoard: 'Board',
  newRepairTicket: '+ Neuer Reparaturauftrag',
  totalTickets: 'Aufträge gesamt',
  allStatuses: 'Alle Status',
  allTypes: 'Alle Typen',
  createdFrom: 'Erstellt von',
  createdTo: 'Erstellt bis',
  priceMinPlaceholder: 'CHF min',
  priceMaxPlaceholder: 'CHF max',
  filterByCustomer: 'Nach Kunde filtern...',
  filterByDealer: 'Nach Händler filtern...',
  filterByDevice: 'Nach Gerät filtern...',
  emptyTitle: 'Noch keine Reparaturaufträge',
  emptyMessage: 'Erstellen Sie Ihren ersten Reparaturauftrag, um loszulegen',
  noTicketsInColumn: 'Keine Aufträge',
  colCustomerDealer: 'Kunde / Händler',
  colDevice: 'Gerät',
  colCreated: 'Erstellt',
  modalTitle: 'Neuer Reparaturauftrag',
  fieldType: 'Typ',
  fieldCustomer: 'Kunde',
  fieldDealer: 'Händler',
  fieldAccessories: 'Zubehör',
  fieldProblemDescription: 'Problembeschreibung',
  accessoriesPlaceholder: 'z. B. Netzkabel, Fernbedienung',
  searchOrCreateCustomer: 'Kunde suchen oder anlegen...',
  searchOrCreateDealer: 'Händler suchen oder anlegen...',
  fieldDevice: 'Gerät',
  searchSerialOrCreateDevice: 'Seriennummer suchen oder Gerät anlegen...',
  attachDeviceHint:
    'Optional -- Sie können auch nach dem Erstellen weitere Geräte anhand der Seriennummer auf der Auftragsseite zuordnen.',
  createTicket: 'Auftrag erstellen',
  errorLoading: 'Fehler beim Laden der Reparaturaufträge: {{error}}',
  invoiceDraftedAlert:
    'ERP-Dokument wurde erstellt, aber nicht ausgeführt -- es muss dort noch manuell abgeschlossen werden.',
  updateStatusFailed: 'Status konnte nicht aktualisiert werden',
};

const repairs = { en, de };
export default repairs;
